/**
 * combos-look.js — /pages/combos (seção combos-look + snippet combos-look-card).
 *
 * Formato do "Compre o look" da L&F: a cliente escolhe cor/tamanho de cada peça e "Comprar combo completo"
 * adiciona as 3 de uma vez e abre a gaveta do carrinho (midas-cart.js). Peça avulsa é pela página do produto.
 * Tamanho nunca vem pré-selecionado (evita comprar o tamanho errado).
 * No celular as peças ficam numa gaveta inferior, aberta pelo botão abaixo da foto do combo.
 * "Qual meu tamanho?" abre a tabela da peça (a mesma da PDP) num modal; tocar na linha escolhe o tamanho.
 */
(function () {
  'use strict';

  if (window.CombosLook) return;

  var FRIENDLY_ERROR = 'Não foi possível adicionar agora. Tente de novo em instantes.';
  var ADDED_MS = 2500;

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  // Mesma conta da PDP nativa (mt-product-info): Price com juros mensais, ou divisão simples sem juros.
  function installmentValue(price, installments, rate) {
    if (rate > 0) {
      var factor = Math.pow(1 + rate, installments);
      return Math.round(price * rate * factor / (factor - 1));
    }
    return Math.round(price / installments);
  }

  function setBusy(btn, busy) {
    btn.classList.toggle('is-loading', busy);
    if (busy) btn.setAttribute('aria-busy', 'true');
    else btn.removeAttribute('aria-busy');
  }

  function flashAdded(btn) {
    var label = btn.querySelector('[data-cb-label]');
    if (!label) return;
    if (!btn.hasAttribute('data-cb-text')) btn.setAttribute('data-cb-text', label.textContent.trim());
    clearTimeout(btn.__cbTimer);
    btn.classList.add('is-added');
    label.textContent = 'Adicionado ✓';
    btn.__cbTimer = setTimeout(function () {
      btn.classList.remove('is-added');
      label.textContent = btn.getAttribute('data-cb-text');
    }, ADDED_MS);
  }

  // ---------- Carrinho ----------

  function openDrawer() {
    if (window.MidasCart && typeof window.MidasCart.open === 'function') {
      window.MidasCart.open();
      return;
    }
    var drawer = document.getElementById('mini-cart');
    if (drawer) drawer.open = true;
    else window.location.href = '/cart';
  }

  // Avisa o tema (contador + conteúdo da gaveta) e abre a gaveta.
  function refreshCart(sections) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (sections) cart.sections = sections;
        var root = document.documentElement;
        root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        root.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
      })
      .catch(function (error) {
        // As peças já entraram; falhar aqui só deixa o contador desatualizado até a próxima ação.
        console.error('Error in combos-look refreshCart:', error);
      })
      .then(openDrawer);
  }

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'mini-cart' })
    }).then(function (r) {
      // Apps que embrulham o fetch às vezes já consumiram o corpo: lê como texto e tolera falha.
      return r.text().then(function (t) {
        var body = null;
        try { body = JSON.parse(t); } catch (e) { /* corpo vazio ou já lido */ }
        return { ok: r.ok, status: r.status, body: body };
      }, function () { return { ok: r.ok, status: r.status, body: null }; });
    }).then(function (res) {
      if (!res.ok) {
        // 422 traz motivo legível em português (ex.: estoque); o resto vira mensagem amigável.
        var desc = res.status === 422 && res.body && (res.body.description || res.body.message);
        var error = new Error(desc || FRIENDLY_ERROR);
        error.cbFriendly = true;
        throw error;
      }
      document.dispatchEvent(new CustomEvent('combos:added', { detail: { items: items } }));
      return refreshCart(res.body && res.body.sections);
    });
  }

  function friendly(error) {
    if (!(error && error.cbFriendly)) console.error('Error in combos-look addItems:', error);
    return error && error.cbFriendly ? error.message : FRIENDLY_ERROR;
  }

  // ---------- Gaveta das peças (celular) ----------

  var openLook = null;

  function openSheet(look) {
    closeSheet();
    openLook = look;
    look.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var close = look.querySelector('.cb-look__close');
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 50);
  }

  function closeSheet() {
    if (!openLook) return;
    var look = openLook;
    openLook = null;
    look.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    var opener = look.querySelector('[data-cb-sheet-open]');
    if (opener && opener.offsetParent) opener.focus({ preventScroll: true });
  }

  // ---------- "Qual meu tamanho?" (tabela da PDP num modal; tocar na linha escolhe o tamanho) ----------

  var sizeModal = null;

  function openSizeModal(card, trigger) {
    var modal = card.root.closest('.cb').querySelector('[data-cb-size-modal]');
    var source = card.root.querySelector('[data-cb-size-table]');
    if (!modal || !source) return;
    var sizeIndex = card.sizeIndex();
    var current = sizeIndex === -1 ? null : card.selected[sizeIndex];
    var body = modal.querySelector('[data-cb-size-body]');
    body.innerHTML = source.innerHTML;
    toArray(body.querySelectorAll('tr')).forEach(function (row) {
      var cell = row.querySelector('td');
      if (!cell) return;
      var size = cell.textContent.trim();
      if (!card.canPick(sizeIndex, size)) return;
      row.classList.add('is-pick');
      row.setAttribute('data-cb-size-pick', size);
      row.setAttribute('tabindex', '0');
      row.setAttribute('role', 'button');
      row.setAttribute('aria-label', 'Escolher tamanho ' + size);
      if (size === current) row.classList.add('is-current');
    });
    modal.querySelector('[data-cb-size-title]').textContent = card.root.getAttribute('data-cb-product-name') || '';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    sizeModal = { modal: modal, card: card, sizeIndex: sizeIndex, trigger: trigger };
    setTimeout(function () { modal.querySelector('.cb-modal__close').focus({ preventScroll: true }); }, 30);
  }

  function closeSizeModal() {
    if (!sizeModal) return;
    var state = sizeModal;
    sizeModal = null;
    state.modal.hidden = true;
    if (!openLook) document.documentElement.style.overflow = '';
    if (state.trigger) state.trigger.focus({ preventScroll: true });
  }

  function pickSize(row) {
    var state = sizeModal;
    state.card.select(state.sizeIndex, row.getAttribute('data-cb-size-pick'));
    closeSizeModal();
  }

  document.addEventListener('click', function (event) {
    var sizeOpener = event.target.closest('[data-cb-size-open]');
    if (sizeOpener) {
      var cardEl = sizeOpener.closest('[data-cb-card]');
      if (cardEl && cardEl.__cbCard) openSizeModal(cardEl.__cbCard, sizeOpener);
      return;
    }
    if (sizeModal) {
      var row = event.target.closest('[data-cb-size-pick]');
      if (row) { pickSize(row); return; }
      if (event.target.closest('[data-cb-size-close]')) closeSizeModal();
      return;
    }
    var opener = event.target.closest('[data-cb-sheet-open]');
    if (opener) { openSheet(opener.closest('[data-cb-look]')); return; }
    if (event.target.closest('[data-cb-sheet-close]')) closeSheet();
  });
  // O tema bloqueia o Esc nativo dos diálogos; aqui o Esc fecha a tabela de medidas e depois a gaveta das peças.
  document.addEventListener('keydown', function (event) {
    if (sizeModal) {
      if (event.key === 'Escape') { closeSizeModal(); return; }
      var row = event.target.closest && event.target.closest('[data-cb-size-pick]');
      if (row && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); pickSize(row); }
      return;
    }
    if (event.key === 'Escape' && openLook) closeSheet();
  });

  // ---------- Peça ----------

  function Card(root) {
    this.root = root;
    this.variants = JSON.parse(root.querySelector('[data-cb-variants]').textContent);
    this.groups = toArray(root.querySelectorAll('[data-cb-opt]'));
    this.selected = this.groups.map(function (group) {
      var on = group.querySelector('[aria-pressed="true"]');
      return on ? on.getAttribute('data-cb-val') : null;
    });
    this.img = root.querySelector('[data-cb-img]');
    this.price = root.querySelector('[data-cb-price]');
    this.compare = root.querySelector('[data-cb-compare]');
    this.off = root.querySelector('[data-cb-off]');
    this.installments = root.querySelector('[data-cb-installments]');
    this.msg = root.querySelector('[data-cb-msg]');
    root.addEventListener('click', this.onClick.bind(this));
    this.render();
  }

  // Variantes compatíveis com o que já foi escolhido (opção sem escolha vale qualquer valor).
  Card.prototype.matches = function (selected, onlyAvailable) {
    return this.variants.filter(function (v) {
      if (onlyAvailable && !v.available) return false;
      return selected.every(function (value, i) { return value === null || v.options[i] === value; });
    });
  };

  Card.prototype.missing = function () {
    var self = this;
    return this.groups.filter(function (group, i) { return self.selected[i] === null; });
  };

  Card.prototype.variant = function () {
    if (this.missing().length) return null;
    var found = this.matches(this.selected, false)[0];
    return found && found.available ? found : null;
  };

  // Variante usada para mostrar preço/foto enquanto a escolha está incompleta.
  Card.prototype.preview = function () {
    return this.matches(this.selected, true)[0] || this.matches(this.selected, false)[0] || this.variants[0];
  };

  Card.prototype.render = function () {
    var self = this;
    this.groups.forEach(function (group, i) {
      toArray(group.querySelectorAll('[data-cb-val]')).forEach(function (btn) {
        var value = btn.getAttribute('data-cb-val');
        var probe = self.selected.slice();
        probe[i] = value;
        var soldout = self.matches(probe, true).length === 0;
        btn.classList.toggle('is-soldout', soldout);
        btn.setAttribute('aria-disabled', soldout ? 'true' : 'false');
        btn.setAttribute('aria-pressed', value === self.selected[i] ? 'true' : 'false');
      });
      var label = group.querySelector('[data-cb-optval]');
      if (label) label.textContent = self.selected[i] || '';
    });

    var v = this.preview();
    if (this.price) this.price.textContent = money(v.price);
    var hasCompare = v.compare > v.price;
    if (this.compare) {
      this.compare.hidden = !hasCompare;
      if (hasCompare) this.compare.textContent = money(v.compare);
    }
    if (this.off) {
      this.off.hidden = !hasCompare;
      if (hasCompare) this.off.textContent = Math.floor((v.compare - v.price) * 100 / v.compare) + '% OFF';
    }
    if (this.installments) {
      var n = parseInt(this.installments.getAttribute('data-cb-installments'), 10);
      var rate = parseFloat(this.installments.getAttribute('data-cb-rate')) || 0;
      var value = this.installments.querySelector('[data-cb-installment-value]');
      if (n > 0 && value) value.textContent = money(installmentValue(v.price, n, rate));
    }
    // data-cb-fixed: foto escolhida no editor para a peça (ex.: kit), não troca com a cor.
    if (this.img && !this.img.hasAttribute('data-cb-fixed') && v.image && this.img.getAttribute('src') !== v.image) {
      this.img.removeAttribute('srcset');
      this.img.setAttribute('src', v.image);
    }
    this.root.dispatchEvent(new CustomEvent('cb:change', { bubbles: true }));
  };

  Card.prototype.flagMissing = function () {
    var missing = this.missing();
    this.groups.forEach(function (group) { group.classList.toggle('is-missing', missing.indexOf(group) !== -1); });
    if (!missing.length) return false;
    var type = missing[0].getAttribute('data-cb-type');
    this.msg.textContent = type === 'size' ? 'Escolha o tamanho.' : type === 'color' ? 'Escolha a cor.' : 'Escolha uma opção.';
    return true;
  };

  Card.prototype.focusMissing = function () {
    var group = this.missing()[0];
    if (!group) return;
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var first = group.querySelector('[data-cb-val]:not(.is-soldout)');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  };

  Card.prototype.sizeIndex = function () {
    for (var i = 0; i < this.groups.length; i++) {
      if (this.groups[i].getAttribute('data-cb-type') === 'size') return i;
    }
    return -1;
  };

  // Tamanho da tabela que existe à venda e tem estoque com a cor escolhida (ex.: XG da tabela do Body Confort não existe).
  Card.prototype.canPick = function (i, value) {
    if (i === -1) return false;
    var btn = toArray(this.groups[i].querySelectorAll('[data-cb-val]')).filter(function (b) {
      return b.getAttribute('data-cb-val') === value;
    })[0];
    return !!btn && !btn.classList.contains('is-soldout');
  };

  Card.prototype.select = function (i, value) {
    if (i < 0) return;
    this.selected[i] = value;
    this.groups[i].classList.remove('is-missing');
    if (!this.missing().length) this.msg.textContent = '';
    this.render();
  };

  Card.prototype.onClick = function (event) {
    var valBtn = event.target.closest('[data-cb-val]');
    if (!valBtn || valBtn.classList.contains('is-soldout')) return;
    this.select(this.groups.indexOf(valBtn.closest('[data-cb-opt]')), valBtn.getAttribute('data-cb-val'));
  };

  // ---------- Combo ----------

  function Look(root) {
    this.root = root;
    this.cards = toArray(root.querySelectorAll('[data-cb-card]')).map(function (el) { return el.__cbCard; });
    this.total = root.querySelector('[data-cb-look-total]');
    this.compare = root.querySelector('[data-cb-look-compare]');
    this.msg = root.querySelector('[data-cb-look-msg]');
    this.btn = root.querySelector('[data-cb-add-look]');
    root.addEventListener('cb:change', this.render.bind(this));
    if (this.btn) this.btn.addEventListener('click', this.add.bind(this));
    this.render();
  }

  Look.prototype.render = function () {
    if (!this.total) return;
    var total = 0;
    var compare = 0;
    this.cards.forEach(function (card) {
      var v = card.preview();
      total += v.price;
      compare += v.compare > v.price ? v.compare : v.price;
    });
    this.total.textContent = money(total);
    if (this.compare) {
      this.compare.hidden = !(compare > total);
      this.compare.textContent = money(compare);
    }
    var each = this.root.querySelector('[data-cb-look-each]');
    if (each) each.textContent = money(Math.round(total / (parseInt(each.getAttribute('data-cb-each-count'), 10) || 1)));
    if (this.msg && this.cards.every(function (card) { return !card.missing().length; })) this.msg.textContent = '';
  };

  Look.prototype.add = function () {
    var self = this;
    var btn = this.btn;
    if (btn.getAttribute('aria-busy') === 'true') return;
    var pending = this.cards.filter(function (card) { return card.flagMissing(); });
    if (pending.length) {
      // No kit (combos-kit) o aviso já aparece nas escolhas do kit; o botão traz data-cb-missing-msg="".
      this.msg.textContent = btn.hasAttribute('data-cb-missing-msg') ? btn.getAttribute('data-cb-missing-msg') : 'Escolha o tamanho de cada peça para comprar o combo.';
      pending[0].focusMissing();
      return;
    }
    var variants = this.cards.map(function (card) { return card.variant(); });
    if (variants.indexOf(null) !== -1) {
      this.msg.textContent = 'Uma das peças esgotou nessa combinação. Escolha outra opção.';
      return;
    }
    this.msg.textContent = '';
    setBusy(btn, true);
    addItems(variants.map(function (v) { return { id: v.id, quantity: 1 }; }))
      .then(function () { flashAdded(btn); closeSheet(); })
      .catch(function (error) { self.msg.textContent = friendly(error); })
      .then(function () { setBusy(btn, false); });
  };

  // ---------- Kit Compre 1 Leve 2 (seção combos-kit): as 2 peças seguem a combinação de cores do kit ----------

  function KitPieces(root) {
    this.root = root;
    this.card = root.querySelector('[data-cb-card]').__cbCard;
    this.fixed = root.getAttribute('data-cb-kit-colors') || '';
    this.pieces = toArray(root.querySelectorAll('[data-cb-piece]'));
    try {
      this.photos = JSON.parse(root.querySelector('[data-cb-piece-photos]').textContent);
    } catch (error) {
      console.error('Error in combos-look KitPieces photos:', error);
      this.photos = {};
    }
    root.addEventListener('cb:change', this.render.bind(this));
    this.render();
  }

  KitPieces.prototype.colors = function () {
    var card = this.card;
    var index = -1;
    card.groups.forEach(function (group, i) { if (group.getAttribute('data-cb-type') === 'color') index = i; });
    var value = index === -1 ? this.fixed : (card.selected[index] || '');
    return value.split('+').map(function (c) { return c.trim(); });
  };

  KitPieces.prototype.render = function () {
    var self = this;
    var colors = this.colors();
    this.pieces.forEach(function (piece, i) {
      var color = colors[i];
      if (!color) return;
      var label = piece.querySelector('[data-cb-piece-color]');
      if (label) label.textContent = color;
      var img = piece.querySelector('[data-cb-piece-img]');
      var url = self.photos[color.toLowerCase()];
      if (img && url) {
        var src = url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=600';
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      }
    });
  };

  function init(scope) {
    scope = scope || document;
    toArray(scope.querySelectorAll('[data-cb-card]')).forEach(function (el) {
      if (!el.__cbCard) el.__cbCard = new Card(el);
    });
    toArray(scope.querySelectorAll('[data-cb-look]')).forEach(function (el) {
      if (!el.__cbLook) el.__cbLook = new Look(el);
    });
    toArray(scope.querySelectorAll('[data-cb-kit-look]')).forEach(function (el) {
      if (!el.__cbKit) el.__cbKit = new KitPieces(el);
    });
  }

  window.CombosLook = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
